import React from "react";
import {ControlLabel, FormControl, Radio, Button} from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import {browserHistory} from "react-router";
import context from "./../../lib/context.js";
import TimecardList from "./../shared/timecard-list.jsx";
import TimecardListItem from "./../shared/timecard-list-item.jsx";

export default class SearchForm extends React.Component {
    constructor(props) {
        super(props);       
        this.onFieldChange = this.onFieldChange.bind(this);      
        this.countSelectedItem = this.countSelectedItem.bind(this);
        this.inputs = {};
    }

    onFieldChange(fieldName, value, callback) {       
        var patch = {
            [fieldName] : value
        };        
        this.props.onFieldChange({search: patch}, callback);
    }

    countSelectedItem() {
        try {
            let count = 0;
            let vm = this.props.vm;
            for(let i = 0; i < vm.timecardList.timecards.length; i++) {
                let tc = vm.timecardList.timecards[i].timecardSummary;                
                if (tc.isChecked && !(tc.isEdited || tc.isIncomplete)) count ++;
            }

            return count;
        } catch(e) {
            console.log(e);
            return 0;
        }
    }

    render() {  
        const self = this;
        let vm = this.props.vm;        
        if (vm != null) { 
            let totalPage = vm.timecardList.total / vm.pageSize + 
            (vm.timecardList.total % vm.pageSize > 0 ? 1 : 0);        
            let verifyTcButtonClass = "ap-fullsize ";
            let verifyTcButtonDisabled = false;
            if (this.countSelectedItem() > 0) verifyTcButtonClass += "btn-info";
            else verifyTcButtonDisabled = true;

            return(            
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">                            
                            <Radio name="radioTCStatus" value="submitted" 
                            checked={vm.status === "submitted"} 
                            onChange={(evt) => this.onFieldChange("status", evt.target.value, this.props.onSearch)}>Submitted Timecards ({vm.countSubmitted})</Radio>
                            <Radio name="radioTCStatus" value="saved" 
                            checked={vm.status === "saved"} 
                            onChange={(evt) => this.onFieldChange("status", evt.target.value, this.props.onSearch)}>Unsubmitted Timecards ({vm.countUnsubmitted})</Radio>                            
                        </div>
                        <div className="col-md-9">
                            <div className="ap-timecard-list-legend">
                                <div className="ap-h4">
                                    To examine a particular timecard and/or modify it, please click on the Associate's name.
                                </div>
                                <div>
                                    <table>
                                        <tr>
                                            <td><span className="fa fa-calendar-check-o ap-blue-color"/></td>
                                            <td>This icon indicates that a specific timecard has been pre-verified by a Payroll Admin. This timecard still needs final verification from the Supervisor.</td>
                                        </tr>
                                        <tr>
                                            <td><span className="glyphicon glyphicon-edit ap-error-color"/></td>
                                            <td>This icon indicated that a specific timecard has been altered from the system time. This timecard needs to be approved separately.</td>
                                        </tr>
                                        <tr>
                                            <td><span className="fa fa-calendar-times-o ap-error-color"/></td>
                                            <td>Missing Clock Out Timecard. This icon indicates that there is missing clock out for timecard. This timecard needs to be approved separately.</td>
                                        </tr>
                                        <tr>
                                            <td><span className="fa fa-suitcase ap-error-color"/></td>
                                            <td>Unapproved Time-Off. This icon indicates that there is Time-Off that has not been approved by the supervisor. The Time-Off will be approved when the timecard is approved separately.</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">                            
                            <TimecardList vm={vm.timecardList} totalPage={totalPage} page={vm.page} onNavigate={this.props.onNavigate}                            
                            onTcItemChecked={this.props.onTcItemChecked} role={this.props.role}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button className={verifyTcButtonClass} 
                                onClick={() => self.props.onVerify()}
                                disabled={verifyTcButtonDisabled}>Verify Selected Timecards</Button>
                        </div>
                    </div>                    
                </div>
                );            
        } else {
            return(
                <div className="container">
                    <div className="row">
                        
                    </div>
                </div>
                );
        }
    }
}